var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{ref:"getSchoolSubject",staticStyle:{"height":"400px"}}),_c('div',{ref:"getStudentSchoolSubject",staticStyle:{"height":"400px"}}),_c('div',{ref:"getTeacherSchoolSubject",staticStyle:{"height":"400px"}})])}
var staticRenderFns = []

export { render, staticRenderFns }